<template>
  <div class="app-options-detail">
    <div class="options-item">
      <OptionsDetailsItem v-for="(item, index) in itemList" :showSummaryText="showSummaryText" :key="index" :item="item" :show-header="showHeader">
        <template v-for="slot in possibleChildSlotsFor('DetailItem')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </OptionsDetailsItem>
    </div>
    <b-row class="row-of-summary" v-if="showSummary">
      <b-col class="left-box table-box">
        <slot name="txtSummaryHead"><p class="summary-head">Deine Gesamtkosten</p></slot>
        <slot name="txtSummaryContent"><p class="summary-content">Summe (inkl. 19% MwSt.)</p></slot>
      </b-col>
      <b-col class="right-box table-box">
        <slot name="summaryAmount"><p class="summary-amount">{{ summedUpPrice }}</p></slot>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import slotProxy from '@/mixins/slotProxy'
import price from '@/mixins/price'
import OptionsDetailsItem from '@/components/process/generic/Tariff/fyve/OptionsDetailsItem.vue'

export default {
  name: 'ListOptionsDetails',
  components: { OptionsDetailsItem },
  props: {
    showHeader: {
      type: Boolean,
      default: false
    },
    showSummaryText: {
      type: Boolean,
      default: true
    },
    showSummary: {
      type: Boolean,
      default: false
    },
    itemList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    summedUpPrice: function () {
      let amount = 0
      this.itemList.forEach(item => {
        if (item.tariffoptionId !== undefined) {
          amount += item.price
        } else if (item.tariffId !== undefined) {
          amount += item.basicFee
        }
      })
      if (amount !== 0) {
        return this.price(amount)
      } else {
        return 'kostenlos'
      }
    }
  },
  mixins: [
    slotProxy(),
    price
  ]
}
</script>
